var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:close-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 12.7077L6.75399 17.9537C6.66065 18.0471 6.54599 18.0971 6.40999 18.1037C6.27399 18.1104 6.15265 18.0604 6.04599 17.9537C5.93932 17.8471 5.88599 17.7291 5.88599 17.5997C5.88599 17.4704 5.93932 17.3524 6.04599 17.2457L11.292 11.9997L6.04599 6.75374C5.95265 6.66041 5.90265 6.54574 5.89599 6.40974C5.88932 6.27374 5.93932 6.15241 6.04599 6.04574C6.15265 5.93908 6.27065 5.88574 6.39999 5.88574C6.52932 5.88574 6.64732 5.93908 6.75399 6.04574L12 11.2917L17.246 6.04574C17.3393 5.95241 17.4543 5.90241 17.591 5.89574C17.7263 5.88908 17.8473 5.93908 17.954 6.04574C18.0607 6.15241 18.114 6.27041 18.114 6.39974C18.114 6.52908 18.0607 6.64708 17.954 6.75374L12.708 11.9997L17.954 17.2457C18.0473 17.3391 18.0973 17.4541 18.104 17.5907C18.1107 17.7261 18.0607 17.8471 17.954 17.9537C17.8473 18.0604 17.7293 18.1137 17.6 18.1137C17.4707 18.1137 17.3527 18.0604 17.246 17.9537L12 12.7077Z",
    fill: "#173325"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2b4e40a8150e322d77ff235baea75cc9.svg";
export { ForwardRef as ReactComponent };